import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  zeroPadding: {
    padding: 0,
  },
  boxWrapper: {
    maxWidth: '100%',
    marginRight: 0,
  },
  description: {
    margin: '10px 0',
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  documentsBox: {
    minHeight: 80,
  },
}));
